export const environment = {
  production: false,
  brandName: "75F",
  caretakerUrl: "https://caretaker.dev.service.75f.io/api/v1",
  publicUrl: "/reports/public",
  deploymentConfig: {
    multiRegion: false,
    defaultRegion: 1,
    regions: {
      1: {
        regionName: "North America" ,
        endpoints: {
          siloUrl: "https://silo.dev.service.75f.io",
          buildingAnalyticsUrl: "https://bas.dev.service.75f.io",
          reportingUrl: "https://auto-cx-dev.75f.io",
          fddUrl: "https://fdd.dev.service.75f.io"
        }
      }
    }
  }
};
